import {Component} from '@angular/core';

@Component({
    selector: 'app-floating-button',
    templateUrl: './floating-button.component.html',
    standalone: false
})
export class FloatingButtonComponent {
}
